<template>
<div id="allcarservices">
    <section class="section2">
        <div class="section2_con1">
            <div class="section2_left">
                <img src="/static/uploads/2018/09/20/22/50/img2/car.svg">
            </div>
            <div class="section2_right">
                <div class="section2_right_cont">
                    <img class="astramotors" src="/static/uploads/2018/09/20/22/50/img2/astramotors.svg">
                    <div class="section2_right_text">
                        <div class="section2_right_text_pos">
                            <p class="section2_right_text_am">
                                Astra Motors
                            </p>
                            <div class="stars_pos">
                                <div><img src="/static/uploads/2018/09/20/22/50/img2/s1w.svg"></div>
                                <div><img src="/static/uploads/2018/09/20/22/50/img2/s1w.svg"></div>
                                <div><img src="/static/uploads/2018/09/20/22/50/img2/s1w.svg"></div>
                                <div><img src="/static/uploads/2018/09/20/22/50/img2/s1w.svg"></div>
                                <div><img src="/static/uploads/2018/09/20/22/50/img2/s2w.svg"></div>
                            </div>
                        </div>
                        <div class="section2_right_text_ad">
                            (г. Москва, ул. Новохохловская, д. 36)
                        </div>
                        <div class="section2_right_images">
                            <router-link to="#"><img src="/static/uploads/2018/09/20/22/50/img2/p1.svg"></router-link>
                            <router-link to="#"><img src="/static/uploads/2018/09/20/22/50/img2/p2.svg"></router-link>
                            <router-link to="#"><img src="/static/uploads/2018/09/20/22/50/img2/p3.svg"></router-link>
                            <router-link to="#"><img src="/static/uploads/2018/09/20/22/50/img2/p4.svg"></router-link>
                            <router-link to="#"><img src="/static/uploads/2018/09/20/22/50/img2/p5.svg"></router-link>
                            <router-link to="#"><img src="/static/uploads/2018/09/20/22/50/img2/p6.svg"></router-link>
                        </div>
                    </div>
                </div>
                <div class="section2_right_under_text">
                    <div class="justline"></div>
                    <div class="section2_right_under_text1">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets.</div>
                </div>
            </div>

        </div>
    </section >

    <section class="section3">
        <div class="section3_title">
            <p class="section3_title1">
                Получить лучшую стоимость ремонта<br>
                <span class="section3_title2">в этом или другом сервисе</span>
            </p>
            <div class="section3_grid">
                <div class="section3_grid_cont">
                    <input type="text" placeholder="Выберите марку" class="section4_grid_bf">
                </div>
                <div class="section3_grid_cont">
                    <input type="text" placeholder="Выберите модель" class="section4_grid_bf">
                </div>
                <div class="section3_grid_cont">
                    <input type="text" placeholder="Выберите категорию" class="section4_grid_bf">
                </div>
                <div class="section3_grid_cont">
                    <input type="text" placeholder="Выберите вид работ" class="section4_grid_bf">
                </div>
                <div class="section3_grid_cont">
                    <input type="number" placeholder="+ 7 (___)___-__-__" class="section4_grid_bf">
                </div>

                <div class="section3_grid_cont">
                    <input type="text" placeholder="Имя" class="section4_grid_bf">
                </div>

            </div>
            <div class="section3_but">
                <router-link to="#"><div class="section3_but_log">записаться</div></router-link>
            </div>
            <div class="section3_but_under">
                <input type="checkbox" class="section3_but_under_box">
                <div class="section3_but_under_text1">
                    Я соглашаюсь c
                </div>
                <div class="section3_but_under_text2">
                    <div>условиями обработки персональных данных</div>
                </div>
            </div>
        </div>
    </section>

    <section class="section4">
        <div class="section4_pos">
            <div class="section4_title">
                <p class="section4_title1">Отзовы о Astra Motors</p>
                <div class="section4_text2">
                    <div class="section4_text2_l">
                        <div class="section4_text2_who">
                            Фёдор Хлебов
                        </div>
                        <div>
                            <div class="section4_text2_l_s">
                                <img src="/static/uploads/2018/09/20/22/50/img2/s1w.svg">
                                <img src="/static/uploads/2018/09/20/22/50/img2/s1w.svg">
                                <img src="/static/uploads/2018/09/20/22/50/img2/s1w.svg">
                                <img src="/static/uploads/2018/09/20/22/50/img2/s1w.svg">
                                <img src="/static/uploads/2018/09/20/22/50/img2/s1w.svg">
                            </div>
                        </div>
                    </div>
                    <div class="section4_text2_car_and_data">
                        <div class="section4_text2_car">
                            Volkswagen Golf V
                        </div>
                        <div class="section4_text2_data">
                            12.10.2017 14:32
                        </div>
                    </div>
                    <div class="section4_text2_cont">
                        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets.
                    </div>
                </div>
                <div class="section4_text3">

                    <div class="section4_text3_l">
                        <div class="section4_text2_who">
                            Александр Некрасов
                        </div>
                        <div>
                            <div class="section4_text2_l_s">
                                <img src="/static/uploads/2018/09/20/22/50/img2/s1w.svg">
                                <img src="/static/uploads/2018/09/20/22/50/img2/s1w.svg">
                                <img src="/static/uploads/2018/09/20/22/50/img2/s1w.svg">
                                <img src="/static/uploads/2018/09/20/22/50/img2/s1w.svg">
                                <img src="/static/uploads/2018/09/20/22/50/img2/s2w.svg">
                            </div>
                        </div>
                    </div>
                    <div class="section4_text3_car_and_data">
                        <div class="section4_text3_car">
                            BMW 325 E36
                        </div>
                        <div class="section4_text3_data">
                            10.07.2018 18:12
                        </div>
                    </div>
                    <div class="section4_text3_cont">
                        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets.
                    </div>

                </div>
            </div>
            <div class="section4_grid">
                <div class="section4_grid_bfer">
                    <input type="text" placeholder="Выберите категорию" class="section4_grid_bf">
                </div>
                <div class="section4_grid_bfer">
                    <input type="text" placeholder="Выберите категорию" class="section4_grid_bf">
                </div>
                <div class="section4_grid_bfer">
                    <input type="text" placeholder="Ваше имя" class="section4_grid_bf">
                </div>
                <div class="section4_grid_sta">
                    <img src="/static/uploads/2018/09/20/22/50/img2/SU.svg">
                    <img src="/static/uploads/2018/09/20/22/50/img2/SU.svg">
                    <img src="/static/uploads/2018/09/20/22/50/img2/SU.svg">
                    <img src="/static/uploads/2018/09/20/22/50/img2/SU.svg">
                    <img src="/static/uploads/2018/09/20/22/50/img2/SU.svg">
                </div>

            </div>
            <input type="text" placeholder="Введетие отзыв" class="section4_grid_bf1">
            <router-link to="#"><div class="section4_grid_but">
                Сохранить
            </div></router-link>
        </div>
    </section>

    <section class="section5">
        <div class="section5_pos">
            <p class="section5_title">
                Истории ремонта автомобиля
            </p>
            <div class="section5_grid">
                <div class="section5_cont">

                    <div class="section5_cont_title">
                        <div class="section5_cont_title_l">
                            <div class="section5_cont_title_b1">Фёдор Хлебов</div>
                            <div class="section5_cont_title_b2">12.10.2017 14:32</div>
                        </div>
                        <div class="section5_cont_title_r">
                            <img src="/static/uploads/2018/09/20/22/50/img2/s1w.svg">
                            <img src="/static/uploads/2018/09/20/22/50/img2/s1w.svg">
                            <img src="/static/uploads/2018/09/20/22/50/img2/s1w.svg">
                            <img src="/static/uploads/2018/09/20/22/50/img2/s1w.svg">
                            <img src="/static/uploads/2018/09/20/22/50/img2/s1w.svg">
                        </div>

                    </div>
                    <div class="section5_cont_line">

                    </div>
                    <div class="section5_cont_text">
                        <div class="section5_cont_text_title">
                            Услуга "Полировка авто"
                        </div>
                        <div class="section5_cont_tex2">
                            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem
                            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem
                            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem
                            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem

                        </div>
                    </div>

                </div>
                <div class="section5_cont">

                    <div class="section5_cont_title">
                        <div class="section5_cont_title_l">
                            <div class="section5_cont_title_b1">Александр Некрасов</div>
                            <div class="section5_cont_title_b2">10.07.2018 18:12</div>
                        </div>
                        <div class="section5_cont_title_r">
                            <img src="/static/uploads/2018/09/20/22/50/img2/s1w.svg">
                            <img src="/static/uploads/2018/09/20/22/50/img2/s1w.svg">
                            <img src="/static/uploads/2018/09/20/22/50/img2/s1w.svg">
                            <img src="/static/uploads/2018/09/20/22/50/img2/s1w.svg">
                            <img src="/static/uploads/2018/09/20/22/50/img2/s2w.svg">
                        </div>

                    </div>
                    <div class="section5_cont_line">

                    </div>
                    <div class="section5_cont_text">
                        <div class="section5_cont_text_title">
                            Услуга "Замена фильтра"
                        </div>
                        <div class="section5_cont_tex2">
                            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy
                            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem
                            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem
                            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem
                        </div>
                    </div>

                </div>
                <div class="section5_cont">

                    <div class="section5_cont_title">
                        <div class="section5_cont_title_l">
                            <div class="section5_cont_title_b1">Павел Савченко</div>
                            <div class="section5_cont_title_b2">2.04.2018 16:49</div>
                        </div>
                        <div class="section5_cont_title_r">
                            <img src="/static/uploads/2018/09/20/22/50/img2/s1w.svg">
                            <img src="/static/uploads/2018/09/20/22/50/img2/s1w.svg">
                            <img src="/static/uploads/2018/09/20/22/50/img2/s1w.svg">
                            <img src="/static/uploads/2018/09/20/22/50/img2/s1w.svg">
                            <img src="/static/uploads/2018/09/20/22/50/img2/s1w.svg">
                        </div>

                    </div>
                    <div class="section5_cont_line">

                    </div>
                    <div class="section5_cont_text">
                        <div class="section5_cont_text_title">
                            Услуга "Шиномонтаж"
                        </div>
                        <div class="section5_cont_tex2">
                            Lorem Ipsum is simply dummy text of the
                            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem
                            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem
                            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem

                        </div>
                    </div>

                </div>
            </div>
        </div>
    </section>
</div>
</template>

<script>
export default {
  name: 'AllCarServices'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AllCarServices.vue